import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import MainImage from '../../wholeme/molecules/mainImage/MainImage';
import {
  noListContainerStyle,
} from './AffinityNetworkStyles';
import appStrings, { SUPPORT_MAILTO } from '../../../common/app_strings';

const { affinityNetwork: { affinityMemberList } } = appStrings;

const AffinityMemberEmptyList = () => (
  <Box sx={noListContainerStyle}>
    <Stack sx={{ paddingTop: '3rem', gap: '2rem' }}>
      <Typography sx={{ fontWeight: 700, fontSize: '24px' }}>
        {affinityMemberList.uhOh}
        <br />
        {affinityMemberList.listNotFound}
      </Typography>
      <Stack sx={{ justifyContent: 'center', flexDirection: 'row' }}>
        <Typography>{affinityMemberList.tryRefresh}</Typography>
          &nbsp;
        <Typography
          component="a"
          href={SUPPORT_MAILTO}
          sx={{
            color: '#5981D1',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {affinityMemberList.contactSupport}
        </Typography>
      </Stack>
    </Stack>
    <MainImage
      imageSrc="assets/profile/career/career-stage.svg"
      imageAlt="forklift"
      imageStylesOverride={{ width: '70%' }}
    />
  </Box>
);

export default AffinityMemberEmptyList;
